// extracted by mini-css-extract-plugin
export default {"container":"TripleCardSection_container__+EEc5","cardList":"TripleCardSection_cardList__0CNgo"};